import { render } from "./ProcessSection.vue?vue&type=template&id=a12dc9e6&scoped=true"
import script from "./ProcessSection.vue?vue&type=script&lang=js"
export * from "./ProcessSection.vue?vue&type=script&lang=js"

import "./ProcessSection.vue?vue&type=style&index=0&id=a12dc9e6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a12dc9e6"]])

export default __exports__